import $ from "jquery";
import loader_gif from "../../images/preloader.gif";
import {Svg as svg} from "./svg";
import {reachGoal} from "js/utils/analytics";

export default class FavItem {
    constructor(isMobile = false) {
        this.isMobile = isMobile
        this.$headerCard = $('.header-favorite-block')
    }

    event() {
        $(document).on('click', '[data-toggle="favorite-item"]', this.handleTextButton.bind(this));
    }

    handleTextButton(e) {
        e.preventDefault();
        let $button = $(e.currentTarget);
        if ($button.prop('disabled')) return;

        let type = $button.data('type')
        let article = $button.data('article');
        let brand = $button.data('brand');

        if (type === 'search-card') {
            reachGoal('to_favorites_search_results')
        } else if (type === 'product-card') {
            reachGoal('to_favorites_product_card')
        }

        $button.prop('disabled', true).removeClass('b-border-dashed');
        $button.html('<img alt="Загрузка" src="' + loader_gif + '" width="25" /> Подождите ...');

        return $.ajax({
            url: '/q/fav-add',
            method: 'POST',
            data: {'article': article, 'brand': brand}
        }).then((data) => {
            if ($button.data('favor-added') === true) {
                $button.html((this.isMobile ? svg.favoriteOutBlue() : svg.favoriteOutBlueDesktop()) + 'В избранное');
                $button.data('favor-added', false);
            } else {
                $button.html((this.isMobile ? svg.favoriteInBlue() : svg.favoriteInBlueDesktop()) + 'В избранном');
                $button.data('favor-added', true);
            }

            if (data.count > 0) {
                if (this.isMobile) {
                    this.$headerCard.find('.badge-block').text(data.count).removeClass('hide')
                } else {
                    this.$headerCard.find('.badge').text(data.count).removeClass('hide')
                    //this.$headerCard.find('.cart-text').addClass('ml-r-1')
                }
            } else {
                if (this.isMobile) {
                    this.$headerCard.find('.badge-block').text(data.count).addClass('hide')
                } else {
                    this.$headerCard.find('.badge').text(data.count).addClass('hide')
                    //this.$headerCard.find('.cart-text').removeClass('ml-r-1')
                }
            }

            $button.prop('disabled', false);
        }).catch((error) => {
            $button.prop('disabled', false);
        });
    }

    declOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return number + ' ' + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }
};
